module.exports = __webpack_public_path__ + "static/ux-benefits-hero-16f42319ac547c1482dad0cf358ce970.png";